package br.com.vvrefeicoes.portal.domain.model

data class PublicMonitor(
    val companyId: String,
    val companyName: String,
    val active: Boolean,
    val buttonCount: Int = 4,
    val services: List<PublicMonitorService> = emptyList(),
)

data class PublicMonitorAnalytics(
    val totalVotes: Int = 0,
    val ratingsByType: Map<String, Int> = emptyMap(),
    val totalVotesByService: Map<String, Int> = emptyMap(),
    val ratingsByService: Map<String, Map<String, Int>> = emptyMap(),
    val services: List<PublicMonitorService> = emptyList(),
)

data class PublicMonitorService(
    val name: String,
    val startTime: String,
    val endTime: String,
)

object MonitorCode {
    fun fromCompanyId(companyId: String): String = companyId.replace("-", "").take(16).lowercase()
}
